const answer1 = `
    <div>
        <p>The market moves rapidly. Because there is such a large amount of data, businesses worldwide could very well be making decisions that are primarily data driven, given that it is more deeply analyzed.</p>
        <br/>
        <p>Our data science course will equip you with the skills needed to assess and predict data accurately, which will ultimately lead to better decision making in business.</p>
    </div>
`

const answer4 = `
    <div>
        <p>Upon the completion of our Data Science course you will acquire skills in:</p>
        <ul>
            <li>Data Modeling</li>
            <li>Data Analysis</li>
            <li>Data Visualization</li>
            <li>Algorithms</li>
            <li>Machine Learning</li>
            <li>& We are not even mentioning here what A.I. is going to do in this world? What do you think?</li>
        </ul
    </div>
`

const faqs = {
    q1: {
      question: "Why Take This Course?",
      answer: answer1,
    },
    q2: {
      question: "What Will I Achieve?",
      answer:
        "By the end of our Data Science course, you can expect to be able to use multiple data sources, understand data quality, and apply different modeling techniques to make predictions. You will be able to apply and communicate your findings to different audiences in a variety of formats through various Data Visualization tools you will learn throughout the course."
    },
    q3: {
      question: "Who’s in My Class?",
      answer:
        `You’ll find individuals who believe that data is the new oil. They indeed have an intense interest in manipulating data-sets, talk about big-data and analyzing patterns. They see data as an intelligent source for making predictions. From business intelligence analysts looking to upskill to recent grads starting new career paths.`
    },
    q4: {
      question: "What Skills Will I Leave With?",
      answer: answer4,
    },
    q5: {
        question: "Any Work Before Class?",
        answer: `Actually, yes! You’ll be required to complete 15-20 hours of pre-work.`
    },
    q6: {
        question: "What Should I Bring to Class?",
        answer: `Make sure you bring a laptop! (MacBook, preferred)`
    }
  };


export default faqs;